import style from "./style.module.scss";
import dynamic from "next/dynamic";
import TextFields from "@/src/views/components/Inputs/Textfields";
import { useDispatch, useSelector } from "react-redux";
import { regex } from "@/src/services/utils/functions/regex";
import { useRouter } from "next/router";
import { useContext, useEffect, useRef, useState } from "react";
import {
  getCaptcha,
  loginAction,
  logoutAction,
  // termsAndConditionsAction,
} from "@/src/application/actions/loginPage";
import Cookies from "universal-cookie";
import { encode } from "js-base64";
import { loginRepository } from "@/src/services/repository/login";
import ButtonBase from "@/src/views/components/Button";
import Skeleton from "@/src/views/components/Skeleton";
import Alert from "@/src/views/components/Alert";
import Typography from "@/src/views/components/Typography";
import Icon from "@/src/views/components/Icon";
import {
  useDevice,
  useGetLocalStorage,
  useOnClickOutside,
} from "@/src/services/hooks";
// import TermsAndCondition from "../terms_and_condition";
import { getIpAddressDatas } from "../../../../../../application/actions/userTracking";
import { LandingLoginContext } from "../../../context/LandingLoginContext";
import LoaderGeneralLogin from "@/src/views/components/Loaders/LoaderGeneralLogin";
import {
  fetchDoLoginSingleProduct,
  fetchListProduk,
} from "@/src/services/api/loginPage";

const SpinLoader = dynamic(() => import("@/src/views/components/SpinLoader"));

export interface IModalProps {
  open: boolean;
  handleClose: any;
  title?: any;
  description?: any;
  id?: string;
}

type loginDatasInput = "empty" | "true" | "false";

LandingLogin.defaultProps = {
  id: "",
  title: "Login",
  description: `Yuk, login dulu untuk menggunakan BRIBrain!`,
};

export default function LandingLogin(props: IModalProps) {
  const cookie = new Cookies();
  const numberRegex: RegExp = regex.number;
  const emailRegex: RegExp = regex.email;
  const uuidRegex: RegExp = regex.uuid;
  const dispatch = useDispatch();
  const router = useRouter();
  const device: "mobile" | "desktop" | undefined = useDevice();
  const token = cookie.get("user");

  const { setCaptchaValue, setModalChangePasswordState } =
    useContext(LandingLoginContext);

  const [state, setState] = useState({
    focusPN: false,
    valuePN: "",
    conditionPN: false,
    lengthPN: false,
    errorPN: "",
    focusPassword: false,
    valuePassword: "",
    lengthPasswordCondition: false,
    tipeTextFieldPassword: "password",
    focusCaptcha: false,
    valueCaptcha: "",
    conditionCaptcha: false,
    lengthCaptcha: false,
    openSnackbar: false,
    loginFailedCounter: 0,
    timerMultiplier: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
    maskPassword: true,
    messageSnackbar: "",
  });
  const [showForm, setShowForm] = useState(props.open);
  const [showTerms, setShowTerms] = useState(false);
  const [termsError, setTermsError] = useState("");
  const [isLoginWithEmail, setIsLoginWithEmail] = useState(false);
  const [showLoader, setShowLoader] = useState(false);

  const {
    captchaContent,
    captchaLoading,
    loginDatas,
    loginLoading,
    // termsAndConditionsDatas,
  } = useSelector((stateRedux: any) => stateRedux.loginPage);

  const baseUrl = process.env.NEXT_PUBLIC_BASE_URL;
  const LINK5_PRODUCT_ID = 4;

  console.log("baseUrl Login", baseUrl)
  useEffect(() => {
    dispatch(getCaptcha({}));
  }, []);

  // useEffect(() => {
  //   setShowForm(props.open);
  // }, [props.open]);

  useEffect(() => {
    if (
      loginDatas.status_code !== 200 &&
      loginDatas.length !== 0
      // &&
      // loginDatas.message ===
      // "Captcha yang Anda masukkan salah. Silakan coba kembali."
    ) {
      dispatch(getCaptcha({}));
      setState({
        ...state,
        valueCaptcha: "",
      });
    }
  }, [loginDatas]);

  useEffect(() => {
    if (loginDatas?.status_code === 200) {
      // console.log("loginDatas", loginDatas);

      fetchListProduk(loginDatas?.data?.token)
        .then((res: any) => {
          const accesses = res?.data?.data;
          // console.log("accesses", accesses)

          const userWithAccess = {
            ...loginDatas?.data?.user,
            access: accesses,
          };

          if (typeof window !== undefined) {
            localStorage.setItem("data", JSON.stringify(userWithAccess));
          }
          // console.log("userWithAccess", userWithAccess)

          localStorage.setItem("accesses", JSON.stringify(res?.data?.data));

          if (!accesses) {
            console.log("!accesses");
            if (uuidRegex.test(loginDatas?.data?.token)) {
              props.handleClose();
              setCaptchaValue(state.valueCaptcha);
              setModalChangePasswordState(true);
              return;
            }
            dispatch(getCaptcha({}));
            setState({
              ...state,
              valueCaptcha: "",
            });
            return;
          }

          if (accesses.length > 1) {
            saveUserDataAndToken();
            resetFormState();
            router.push(`${baseUrl}/home`);
            return;
          }

          const directAccess = accesses?.[0];

          if (!directAccess) {
            dispatch(getCaptcha({}));
            setState({
              ...state,
              valueCaptcha: "",
            });
            return;
          }

          // if (directAccess?.product_id === LINK5_PRODUCT_ID) {
          //   dispatch(termsAndConditionsAction(loginDatas?.data?.token));
          //   setShowTerms(!showTerms);
          //   return;
          // }

          const devicesObject = directAccess.device.reduce((acc, item) => {
            acc[item.device] = item;
            return acc;
          }, {});

          const routeDevice = devicesObject[device];

          resetFormState();

          fetchDoLoginSingleProduct(
            directAccess.product_id,
            loginDatas?.data?.token,
          )
            .then((res: any) => {
              const cookie = new Cookies();

              cookie.remove("user", { path: "/" });
              cookie.remove("userData", { path: "/" });

              cookie.set("user", res?.data?.token, {
                path: "/",
                expires: new Date(res?.data?.expire),
                secure: true,
              });
              cookie.set("userData", res?.data?.user, {
                path: "/",
                expires: new Date(res?.data?.expire),
                secure: true,
              });

              localStorage.setItem("data", JSON.stringify(res?.data?.user));

              router.push(`${routeDevice.main_url}${routeDevice.uri}`);
            })
            .catch((error) => {
              console.error("Error fetching accesses:", error);
              // console.log('tidak ada directAccess')
              dispatch(getCaptcha({}));
              setState({
                ...state,
                valueCaptcha: "",
              });
              return;
            });
        })
        .catch((error) => {
          console.error("Error fetching accesses:", error);
        });
    }
  }, [loginDatas]);

  let stylePersonalNumber: loginDatasInput;
  if (loginDatas?.status_code === "200") {
    stylePersonalNumber = "empty";
  } else if (!state.focusPN) {
    stylePersonalNumber = "empty";
  } else if (state.focusPN && state.errorPN.length === 0) {
    stylePersonalNumber = "true";
  } else {
    stylePersonalNumber = "false";
  }

  let stylePassword: loginDatasInput;
  if (loginDatas?.status === "200") {
    // ketika berhasil login d kembalikan seperti semula
    stylePassword = "empty";
  } else if (
    !state.focusPassword &&
    loginDatas?.auth?.helper_text?.password?.length === undefined
  ) {
    stylePassword = "empty";
  } else if (
    !state.focusPassword &&
    loginDatas?.auth?.snackbar?.message?.length === undefined
  ) {
    stylePassword = "empty";
  } else if (
    !state.focusPassword &&
    loginDatas?.auth?.helper_text.password?.length !== 0 &&
    state.lengthPasswordCondition
  ) {
    stylePassword = "empty";
  } else if (
    !state.focusPassword &&
    loginDatas?.auth?.snackbar.message?.length !== 0 &&
    state.lengthPasswordCondition
  ) {
    stylePassword = "empty";
  } else if (state.focusPassword) {
    stylePassword = "true";
  } else {
    stylePassword = "false";
  }

  let styleCaptcha: loginDatasInput;
  if (loginDatas?.auth?.status === "200") {
    styleCaptcha = "empty";
  } else if (
    !state.focusCaptcha &&
    loginDatas?.auth?.helper_text?.captcha?.length === undefined
  ) {
    styleCaptcha = "empty";
  } else if (
    !state.focusCaptcha &&
    loginDatas?.auth?.snackbar?.message?.length === undefined
  ) {
    styleCaptcha = "empty";
  } else if (
    !state.focusCaptcha &&
    loginDatas?.auth?.helper_text.captcha?.length !== 0 &&
    state.lengthCaptcha
  ) {
    styleCaptcha = "empty";
  } else if (
    !state.focusCaptcha &&
    loginDatas?.auth?.snackbar.message?.length !== 0 &&
    state.lengthCaptcha
  ) {
    styleCaptcha = "empty";
  } else if (state.focusCaptcha) {
    styleCaptcha = "true";
  } else {
    styleCaptcha = "empty";
  }

  // useEffect(() => {
  //   dispatch(getIpAddressDatas());
  // }, []);

  const handleChangePN: (e: any) => void = (e: any) => {
    setState({
      ...state,
      valuePN: e.target.value,
      conditionPN:
        numberRegex.test(e.target.value) ||
        e.target.value.length === 0 ||
        emailRegex.test(e.target.value),
      lengthPN: e.target.value.length !== 0,
      errorPN:
        numberRegex.test(e.target.value) ||
        e.target.value.length === 0 ||
        emailRegex.test(e.target.value)
          ? ""
          : // : "Format personal number harus berupa angka",
            "Format personal number atau email salah",
    });
  };
  // const handleChangeEmail: (e: any) => void = (e: any) => {
  //   setState({
  //     ...state,
  //     valuePN: e.target.value,
  //     conditionPN:
  //       e.target.value.length === 0 || emailRegex.test(e.target.value),
  //     lengthPN: e.target.value.length !== 0,
  //     errorPN:
  //       e.target.value.length === 0 || emailRegex.test(e.target.value)
  //         ? ""
  //         : "Format email salah",
  //   });
  // };
  // PN atau Email
  const handleChangeUser: (e: any) => void = (e: any) => {
    // if (isLoginWithEmail) {
    //   handleChangeEmail(e);
    //   return;
    // }
    handleChangePN(e);
  };
  const handleFocusPN: () => void = () => {
    setState({ ...state, focusPN: true });
  };

  const handleBlurPN: () => void = () => {
    setState({ ...state, focusPN: false });
  };

  const conditionClear: { [key: string]: boolean } = {
    pn: state.valuePN.length !== 0,
    captcha: state.valueCaptcha.length !== 0,
  };
  const handleClearPN: () => void = () => {
    setState({ ...state, valuePN: "", errorPN: "" });
  };

  // Password
  const handleChangePassword: (e: any) => void = (e: any) => {
    setState({
      ...state,
      valuePassword: e.target.value,
      lengthPasswordCondition: e.target.value.length !== 0,
    });
  };

  const handleFocusPassword: () => void = () => {
    setState({ ...state, focusPassword: true });
  };

  const handleBlurPassword: () => void = () => {
    setState({ ...state, focusPassword: false });
  };

  // Captcha
  const handleChangeCaptcha: (e: any) => void = (e: any) => {
    setState({
      ...state,
      valueCaptcha: e.target.value,
      lengthCaptcha: e.target.value.length !== 0,
    });
  };

  const handleFocusCaptcha: () => void = () => {
    setState({ ...state, focusCaptcha: true });
  };

  const handleBlurCaptcha: () => void = () => {
    setState({ ...state, focusCaptcha: false });
  };

  const handleClearCaptcha: () => void = () => {
    setState({ ...state, valueCaptcha: "" });
  };

  const handleUnMaskPassword = () => {
    setState({ ...state, maskPassword: !state.maskPassword });
  };

  const handleSubmit: (
    e: any,
    pn: string,
    password: string,
    idCaptcha: string,
    captchaValue: string,
  ) => void = (
    e: any,
    pn: string,
    password: string,
    idCaptcha: string,
    captchaValue: string,
  ) => {
    e.preventDefault();

    setTermsError("");

    dispatch(
      loginAction({
        captcha_id: idCaptcha,
        captcha_value: captchaValue,
        password: encode(password),
        personal_number: pn,
      }),
    );
  };

  // const handleSwitchLoginMethod = () => {
  //   dispatch(getCaptcha({}));
  //   resetFormState();

  //   setIsLoginWithEmail((prev) => !prev);
  // };

  const validation =
    state.valuePN.length !== 0 &&
    state.valuePassword.length !== 0 &&
    state.valueCaptcha.length !== 0 &&
    state.errorPN.length === 0;

  const helperTextPassword = () => {
    return state.valuePassword.length === 0 &&
      state.valuePN.length > 0 &&
      state.valueCaptcha.length > 0
      ? "Mohon masukkan password terlebih dahulu"
      : "";
  };

  const handleAcceptTerms = () => {
    saveUserDataAndToken();
    fetchDoLoginSingleProduct(LINK5_PRODUCT_ID, loginDatas?.data?.token).then(
      (res: any) => {
        const cookie = new Cookies();

        cookie.remove("user", { path: "/" });
        cookie.remove("userData", { path: "/" });

        cookie.set("user", res?.data?.token, {
          path: "/",
          expires: new Date(res?.data?.expire),
          secure: true,
        });

        cookie.set("userData", res?.data?.user, {
          path: "/",
          expires: new Date(res?.data?.expire),
          secure: true,
        });

        localStorage.setItem("data", JSON.stringify(res?.data?.user));

        window.location.assign(`${baseUrl}/link5/monitoring-pipeline`);
        resetFormState();
        setTermsError("");
      },
    );
  };

  const handleDeclineTerms = () => {
    setTermsError(
      "Anda perlu menyetujui terms & condition untuk melihat Dashboard",
    );
    console.log("Kena termmmss logout");

    dispatch(logoutAction(token));
    dispatch(getCaptcha({}));
    setState({
      ...state,
      valueCaptcha: "",
    });
    setShowTerms(false);
  };

  const ref = useRef(document.createElement("div"));
  const termsRef = useRef(document.createElement("div"));

  useOnClickOutside(ref, () => {
    if (showForm && showTerms) {
      props.handleClose();
    }
  });

  useOnClickOutside(termsRef, () => {
    if (showTerms) {
      console.log("kena outsideee");
      dispatch(logoutAction(token));
      setShowTerms(false);
    }
  });

  function saveUserDataAndToken() {
    // console.log("loginDatas?.data?.user", loginDatas?.data?.user)

    setShowForm(false);
    setShowTerms(false);
    setShowLoader(true);
    // if (typeof window !== undefined) {
    //   localStorage.setItem("data", JSON.stringify(loginDatas?.data?.user));
    // }
    const cookie = new Cookies();
    cookie.set("user", loginDatas?.data?.token, {
      path: "/",
      expires: new Date(loginDatas?.data?.expire),
      secure: true,
    });
    cookie.set("userData", loginDatas?.data?.user, {
      path: "/",
      expires: new Date(loginDatas?.data?.expire),
      secure: true,
    });
  }

  function resetFormState() {
    setState({
      ...state,
      valuePN: "",
      valuePassword: "",
      valueCaptcha: "",
      errorPN: "",
    });
  }

  return (
    <>
      <div className={style.backdrop} />
      {showForm && (
        <div className={style.alert_content} ref={ref} id={"dmodal_login"}>
          <div className={style.alert_inner}>
            <div className={style.heading}>
              <div
                className={style.close_button}
                id={"Button_IconOnly_Close"}
                onClick={props.handleClose}
              >
                <Icon select={"remove"} size="36px" color="#BDBDBD" />
              </div>
              <Typography variant="heading-3-bold" color="blue1" align="left">
                {props.title}
              </Typography>

              <Typography
                variant="subtitle-2-medium"
                color="gray-2"
                align="left"
              >
                {props.description}
              </Typography>
            </div>

            {((loginDatas?.message && loginDatas?.message !== "Success") ||
              termsError?.length > 0) && (
              <div className={style.error_wrapper}>
                <Alert id={"alert-login-failed"}>
                  {termsError?.length > 0 ? termsError : loginDatas.message}
                </Alert>
              </div>
            )}

            <div>
              <div
                style={{
                  padding: "0 24px 24px",
                }}
              >
                <div className={style.form_div}>
                  <form
                    onSubmit={
                      validation
                        ? (e: any) =>
                            handleSubmit(
                              e,
                              state.valuePN,
                              state.valuePassword,
                              captchaContent?.data?.id,
                              state.valueCaptcha,
                            )
                        : (e) => e.preventDefault()
                    }
                  >
                    <TextFields
                      label={
                        loginRepository?.[
                          isLoginWithEmail ? "email" : "personal_number"
                        ]?.label
                      }
                      type="text"
                      value={state.valuePN}
                      id="Text_Field_Underline_PN"
                      onChange={handleChangeUser}
                      onFocus={handleFocusPN}
                      onBlur={handleBlurPN}
                      placeholder={
                        loginRepository?.[
                          isLoginWithEmail ? "email" : "personal_number"
                        ]?.placeholder
                      }
                      maxLength={
                        loginRepository?.[
                          isLoginWithEmail ? "email" : "personal_number"
                        ]?.max
                      }
                      onEndAdornment={handleClearPN}
                      endAdornmentCondition={conditionClear.pn}
                      helperText={
                        loginDatas?.length !== 0
                          ? loginDatas?.auth?.helper_text?.personal_number
                          : state.errorPN
                      }
                      helperTextColor="red"
                      condition={stylePersonalNumber}
                      endAdornment={
                        <Icon
                          mode="circle"
                          backgroundColor="light_neutral"
                          select="clear"
                          size="18"
                          color="#fff"
                          rotate="0"
                        />
                      }
                    />
                    <TextFields
                      label={loginRepository?.password?.label}
                      id="Text_Field_Underline_Password"
                      type={state.maskPassword ? "password" : "text"}
                      value={state.valuePassword}
                      onChange={handleChangePassword}
                      onFocus={handleFocusPassword}
                      onBlur={handleBlurPassword}
                      placeholder={loginRepository?.password?.placeholder}
                      maxLength={loginRepository?.password?.max}
                      onEndAdornment={handleUnMaskPassword}
                      endAdornmentCondition={true}
                      helperText={helperTextPassword()}
                      helperTextColor="red"
                      condition={stylePassword}
                      endAdornment={
                        <Icon
                          select={state.maskPassword ? "eye_close" : "eye_open"}
                          size="18"
                          color="#C1C7D0"
                          rotate="0"
                        />
                      }
                    />
                    <TextFields
                      label={loginRepository?.captcha?.label}
                      type="text"
                      id="Text_Field_Underline_Captcha"
                      value={state.valueCaptcha}
                      onChange={handleChangeCaptcha}
                      onFocus={handleFocusCaptcha}
                      onBlur={handleBlurCaptcha}
                      placeholder={loginRepository?.captcha?.placeholder}
                      maxLength={loginRepository?.captcha?.max}
                      onEndAdornment={handleClearCaptcha}
                      endAdornmentCondition={conditionClear.captcha}
                      helperText={
                        loginDatas?.length !== 0
                          ? loginDatas?.auth?.helper_text?.captcha
                          : ""
                      }
                      helperTextColor="red"
                      condition={styleCaptcha}
                      endAdornment={
                        <Icon
                          mode="circle"
                          backgroundColor="light_neutral"
                          select="clear"
                          size="18"
                          color="#fff"
                          rotate="0"
                        />
                      }
                    />

                    {/* Image Captcha */}

                    <div className={style.captcha_wrapper}>
                      {!captchaLoading &&
                      captchaContent?.data?.base64 !== undefined ? (
                        <div className={style.image_wrapper}>
                          <img
                            src={captchaContent?.data?.base64}
                            alt="captcha"
                            style={{ width: "100%", height: "62px" }}
                          />
                        </div>
                      ) : !captchaLoading &&
                        captchaContent?.data?.base64 === undefined ? (
                        <div className={style.error_captcha_wrapper}>
                          <div>
                            {`Loading captcha bermasalah. `}
                            <span
                              onClick={() => dispatch(getCaptcha({}))}
                              className={style.error_captcha_refresh_anchor}
                            >
                              {`Refresh`}
                            </span>
                          </div>
                        </div>
                      ) : (
                        <Skeleton width={310} height={62} />
                      )}
                    </div>

                    {/* button login */}
                    <ButtonBase
                      id={"Button_Primary_Login"}
                      text={
                        !loginLoading
                          ? loginRepository?.login_button?.loading_text
                          : loginRepository?.login_button?.default_text
                      }
                      // type={loginRepository?.login_button?.type}
                      // variant={loginRepository?.login_button?.variant}
                      // size={loginRepository?.login_button?.size}
                      type={"submit"}
                      variant={"primary"}
                      size={"wide"}
                      enabled={validation}
                    >
                      <>{!loginLoading && <SpinLoader />}</>
                    </ButtonBase>
                  </form>
                </div>
              </div>
              {/* <div className={style.alternate_login_wrapper}>
                <Typography variant="subtitle-2-medium" color="gray-2">
                  atau
                </Typography>
                <button
                  id={"Button_Switch_Login_Method"}
                  className={style.button_switch_login_method}
                  onClick={handleSwitchLoginMethod}
                >
                  <Typography variant="subtitle-2-medium" color="blue90">
                    {`Login dengan ${
                      !isLoginWithEmail ? "Email" : "Personal Number atau Email"
                    }.`}
                  </Typography>
                </button>
              </div> */}
            </div>
          </div>
        </div>
      )}
      <div ref={termsRef}>
        {/* {showTerms && (
          <TermsAndCondition
            id={`terms-and-condition`}
            handleClose={handleDeclineTerms}
            handleAcceptTerms={handleAcceptTerms}
            handleDeclineTerms={handleDeclineTerms}
            wording={termsAndConditionsDatas?.data?.value}
          />
        )} */}
      </div>
      {showLoader && <LoaderGeneralLogin />}
    </>
  );
}
